import {
    BasicInput,
    BasicSelect,
    ErrorText,
    InfoTooltip
} from "src/components";
import PeriodInputs from "src/components/PeriodInputs";
import { INTRO_QUESTIONS } from "src/features/esg-survey/constants";

const AccountForm = ({ onChange, values, errors }) => {
  return (
    <>
      {INTRO_QUESTIONS.map((q, idx) => (
        <div key={idx} className={`mb-5 w-100`}>
          <div className="d-flex align-items-baseline">
            <span style={{ fontSize: "20px" }} className="mr-2">
              {idx + 1 + ". "}
            </span>
            <p className="text-left" style={{ fontSize: "20px" }}>
              {q.label} {q.info && <InfoTooltip content={q.info} />}
            </p>
          </div>
          {q.name === "reportingPeriod" ? (
            <PeriodInputs onChange={onChange} data={values} errors={errors} />
          ) : q.options ? (
            <BasicSelect
              options={q.options}
              name={q.name}
              onChange={onChange}
              defaultValue={values[q.name]}
              required
              placeholder={q.placeholder}
            />
          ) : (
            <BasicInput
              name={q.name}
              onChange={onChange}
              defaultValue={values[q.name]}
              placeholder={q.placeholder}
            />
          )}
          {errors[q.name] && <ErrorText className="text-left" value={errors[q.name]} />}
        </div>
      ))}
    </>
  );
};

export default AccountForm;
